import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export const Lightbox = ({ images }) => {
  const [index, setIndex] = useState(null);
  const open = index !== null;
  const show = (i) => setIndex(i);
  const close = () => setIndex(null);
  const prev = (e) => { e.stopPropagation(); setIndex((i) => (i - 1 + images.length) % images.length); };
  const next = (e) => { e.stopPropagation(); setIndex((i) => (i + 1) % images.length); };

  return (
    <>
      <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
        {images.map((img, i) => (
          <motion.button
            key={i}
            onClick={() => show(i)}
            data-testid={`gallery-item-${i}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
            className="group mb-5 block w-full overflow-hidden rounded-2xl border border-slate-200 bg-white break-inside-avoid"
          >
            <div className="overflow-hidden">
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
          </motion.button>
        ))}
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={close}
            data-testid="lightbox"
            className="fixed inset-0 z-[60] flex items-center justify-center bg-brand-blue/95 p-4 backdrop-blur"
          >
            <button onClick={(e) => { e.stopPropagation(); close(); }} type="button" data-testid="lightbox-close" className="absolute right-5 top-5 z-10 text-white/70 hover:text-white">
              <X className="h-8 w-8" />
            </button>
            <button onClick={prev} className="absolute left-4 md:left-8 text-white/70 hover:text-white">
              <ChevronLeft className="h-9 w-9" />
            </button>
            <motion.img
              key={index}
              initial={{ opacity: 0, scale: 0.96 }}
              animate={{ opacity: 1, scale: 1 }}
              src={images[index].src}
              alt={images[index].alt}
              onClick={(e) => e.stopPropagation()}
              className="max-h-[85vh] max-w-[90vw] rounded-xl object-contain"
            />
            <button onClick={next} className="absolute right-4 md:right-8 text-white/70 hover:text-white">
              <ChevronRight className="h-9 w-9" />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
